export const subAppPrefix = 'apps';
export const subAppPathPrefix = `/${subAppPrefix}/`